import React from "react";

export const SphoneIcom = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none">
        <path
          d="M10.0377 5.31622L10.6867 6.47922C11.2717 7.52922 11.0367 8.90522 10.1147 9.82822C10.1147 9.82822 8.99466 10.9472 11.0247 12.9762C13.0517 15.0032 14.1717 13.8862 14.1717 13.8862C15.0947 12.9632 16.4717 12.7282 17.5207 13.3132L18.6837 13.9632C20.2687 14.8472 20.4557 17.0692 19.0627 18.4632C18.2257 19.2992 17.1997 19.9512 16.0667 19.9932C14.1587 20.0662 10.9177 19.5832 7.66666 16.3332C4.41666 13.0822 3.93366 9.84122 4.00666 7.93322C4.04966 6.80022 4.70066 5.77422 5.53666 4.93722C6.93066 3.54422 9.15266 3.73122 10.0367 5.31722"
          fill="white"
        />
      </svg>
    </div>
  );
};
